import { Observable } from "rxjs";
import { BaseService } from "../../../core/services/base.service";
import { AuthResponse, LoginCredentials } from "../interfaces/auth.interface";
import { User } from "../interfaces/user.interface";
import { UserStats } from "../interfaces/user-stats.interface";
import { PageResponse } from "../../../core/interfaces/page-response.interface";
import {
  RegistrationRequest,
  RegistrationResponse,
} from "../interfaces/registration-request.interface";

export abstract class AuthService extends BaseService<any> {
  // Implementing CRUD methods as optional or empty for Auth
  findAll(): Observable<PageResponse<any>> {
    throw new Error("Not implemented");
  }
  find(id: string): Observable<any> {
    throw new Error("Not implemented");
  }
  create(data: any): Observable<any> {
    throw new Error("Not implemented");
  }
  update(id: string, data: any): Observable<any> {
    throw new Error("Not implemented");
  }
  delete(id: string): Observable<void> {
    throw new Error("Not implemented");
  }

  // Implementing Auth methods
  abstract login(credentials: LoginCredentials): Observable<AuthResponse>;
  abstract logout(): Observable<void>;
  abstract forgotPassword(email: string): Observable<void>;
  abstract verifyOtp(
    uniqueId: string,
    contactType: string,
    otpCode: string,
  ): Observable<void>;
  abstract resetPassword(token: string, newPassword: string): Observable<void>;
  abstract currentUser(): Observable<User>;
  abstract currentUserStats(): Observable<UserStats>;
  abstract verifyEmail(otp: string): Observable<void>;
  abstract resendEmailOtp(): Observable<void>;
  abstract updateEmail(email: string): Observable<void>;
  abstract verifyPhone(uniqueId: string, otp: string): Observable<void>;
  abstract resendPhoneOtp(params: {
    uniqueId: string;
    contactType: string;
  }): Observable<boolean>;
  abstract updatePhone(phone: string): Observable<string>;
  abstract acceptTerms(data: {
    isAgreed: boolean;
    isSubscribeTips: boolean;
    isSubscribeCommunity: boolean;
  }): Observable<void>;

  //Registration
  abstract signup(
    registrationRequest: RegistrationRequest,
  ): Observable<RegistrationResponse>;
  abstract updateRegistrationEmail(
    uniqueId: string,
    email: string,
  ): Observable<boolean>;
  abstract updateRegistrationPhone(
    uniqueId: string,
    phone: string,
  ): Observable<boolean>;
  abstract resendRegistrationEmailOtp(uniqueId: string): Observable<boolean>;
  abstract resendRegistrationPhoneOtp(uniqueId: string): Observable<boolean>;
  abstract verifyRegistrationEmailOtp(
    uniqueId: string,
    otp: string,
  ): Observable<boolean>;
  abstract verifyRegistrationPhoneOtp(
    uniqueId: string,
    otp: string,
  ): Observable<boolean>;
  abstract acceptRegistrationTerms(
    uniqueId: string,
    data: {
      isAgreed: boolean;
      isSubscribeTips: boolean;
      isSubscribeCommunity: boolean;
    },
  ): Observable<RegistrationResponse>;
  abstract updateFcmToken(token: string): Observable<any>;

  //Invite
  abstract getInviteDetails(inviteId: string): Observable<RegistrationRequest>;

  abstract signInByRegistration(uniqueId: string): Observable<AuthResponse>;
}
